// Hand a made file to the browser as a download (I-1a Batch 6b; Implementation
// Plan v02 §6.4 "Android uses a download"). A blob URL on an `<a download>`:
// nothing leaves the phone, the browser saves the file (Android: Downloads).
// The iPhone route (share sheet → "Save to Files") comes with I-0b.
//
// The URL is revoked a minute later, not at once: some browsers start reading
// the blob only after the click has returned.

export function saveFile(bytes: Uint8Array<ArrayBuffer>, fileName: string): void {
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/octet-stream' }))
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.rel = 'noopener'
  document.body.append(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
